import type { ReactNode } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

/**
 * Site-wide footer. It carries the link to the GPL notices for the bundled
 * Chessground and the WASM engine (§1.3, R-17), so they are one click away from
 * every page, signed in or not. `children` adds page-specific links before it.
 */
export function SiteFooter({ children }: { children?: ReactNode }): JSX.Element {
  const { pathname } = useLocation();
  return (
    <footer className="site-footer">
      <p>
        <strong>ItsAllPrep</strong> · Thoughtful preparation. Confident play.
      </p>
      <nav aria-label="Footer">
        {children}
        <Link to="/licenses" aria-current={pathname === '/licenses' ? 'page' : undefined}>
          Licenses
        </Link>
      </nav>
    </footer>
  );
}

/** A public page without the app shell: the page, then the footer at the bottom. */
export function PublicFrame(): JSX.Element {
  return (
    <div className="site-frame">
      <div className="site-frame-body">
        <Outlet />
      </div>
      <SiteFooter />
    </div>
  );
}
